// this is an autogenerated file from App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/Filters/AppointmentTypes/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_Content_Content_CollapsibleSidebar_Filters_AppointmentTypes_Content($location_id: uuid!) {
  vaxiom_appointment_templates(
    where: {
      organization: { _id: { _eq: $location_id } }
      deleted: { _eq: false }
    }
    order_by: { full_name_computed: asc }
  ) {
    _id
    full_name: full_name_computed
    color_id: color_id_computed
  }
}

`